import React from "react";
import { Dropdown } from "react-bootstrap";
import { FaChevronDown } from "react-icons/fa";
import "./StageTransitionDropdown.css";

const StageTransitionDropdown = ({
    value,
    options = [],
    onChange,
    placeholder = "Select Stage"
}) => {

    const selected = options?.find(
        opt => opt.childStage === value
    );

    return (
        <Dropdown className="stage-dropdown">
            <Dropdown.Toggle className="stage-dropdown-toggle">
                {selected ? (
                    <div className="selected-label">
                        <div>{selected?.childStage}</div>
                        {/* <small>{selected.parentStage}</small> */}
                    </div>
                ) : (
                    <div className="selected-label">
                        <div>{placeholder}</div>
                    </div>
                )}
                <FaChevronDown />
            </Dropdown.Toggle>

            <Dropdown.Menu className="stage-dropdown-menu">
                {options?.map((opt, index) => (
                    <Dropdown.Item
                        key={index}
                        onClick={() => onChange(opt)}
                        className="stage-dropdown-item"
                    >
                        <div className="stage-item">
                            <div className="stage-main">
                                {opt?.childStage}
                            </div>

                            <div className="stage-parent">
                                {opt?.parentStage}
                            </div>

                            {/* {opt.prerequisites?.length > 0 && (
                                <div className="stage-prereq">
                                    {opt.prerequisites.join(", ")}
                                </div>
                            )} */}
                        </div>
                    </Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default StageTransitionDropdown;